import { CommonModule, NgClass } from "@angular/common";
import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { TestId } from "pax-ui/core";
import { EmojiComponent } from "projects/pax-ui/components/emoji";

import { Emoji } from "../emoji/emoji-alt-mapping";

@Component({
  selector: "pax-section",
  imports: [CommonModule, EmojiComponent],
  templateUrl: "./section.html",
  styleUrls: ["./section.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Section {
  @Input()
  className: NgClass["ngClass"] = "";

  @Input()
  sectionTitle: string | undefined;

  @Input()
  sectionSubtitle: string | undefined;

  @Input()
  emojis: Emoji[] | undefined;

  @Input()
  titleHtmlElement: "h1" | "h2" | "h3" = "h1";

  pageTitleH1TestId = TestId.PAGE_TITLE_H1;
  pageSubTitleTestId = TestId.PAGE_SUBTITLE;
}
